import React, { Component } from 'react';

import './mensajePlan.css';
import '../consumoHome.css';

import Grafico from '../../../../img/graficoPorcentaje.svg'

class MensajePlan extends Component {

    constructor(){
        super();
        this.state = {
            data:{
                labels: ["Mensajes Utilizados", "Total de Mensajes"],
                datasets: [{
                    borderColor: 'rgb(63, 80, 121)',
                    data: [10, 100],
                    backgroundColor: [
                        'rgba(238,60,22,0.6)',
                        'rgba(22,238,238,0.6)',
                    ],
                }]
            }
        };
    }

    render(){
        return(
            <div className='col s12'>
                <div className='card-panel cardConsumo mensajePlanCard'>
                    <div className='containerSelect'>
                        <select className='selecTiempo'>
                            <option value='ultimaSemana'>Últimos 7 días</option>
                            <option value='ultimoMes'>Último Mes</option>
                            <option value='ultimoAnio'>Último Año</option>
                        </select>
                    </div>
                    <p className='tituloHeader headerMensajes'>Mensajes Utilizados</p>
                    <p>Sesiones de los últimos 7 dias</p>
                    <div className='containerGrafico'>
                        {/* Provisional como iuna imagen */}
                        <img src={Grafico} alt='graficoProvisional' />
                        {/* <Doughnut data={this.state.data} id='donoutChartMensajes'/> */}
                        {/* <div className='pieChart' data-value='10'></div> */}
                    </div>
                    {/* <p id='porcentajeDato'>80%</p> */}
                    <p className='informacionGrafico'>Consumo de mensajes</p>
                </div>
            </div>
        );
    }
}

export default MensajePlan;
